import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

import type { IndicatorDto } from '@src/api';
import type { IndicatorDtoDefId } from '@stores/dictionaryStores/indicatorsStore/indicatorsStore';

type IndicatorDtoWithChildrenDto = IndicatorDto & {
  children?: IndicatorDtoWithChildrenDto[];
  key: string;
  title: string;
};

export const toTreeView = (indicators: IndicatorDtoDefId[]): IndicatorDtoWithChildrenDto[] => {
  const output = sortBy(
    indicators.filter((indicator) => indicator.reportGroupCode && indicator.repVers),
    ['reportGroupCode', 'repVers'],
  );

  const withoutGroup = {
    key: 'PCKG',
    title: 'PCKG - информация из кода пакета',
    count: indicators.filter((indicator) => !indicator.repVers).length,
  };

  const withGroup = uniqBy(output, 'reportGroupCode').map((item) => ({
    reportGroupCode: item.reportGroupCode,
    key: item.reportGroupCode ?? '',
    title: `${item.reportGroupCode} - ${item.reportGroupName}`,
    children: uniqBy(
      output.filter((el) => el.reportGroupCode === item.reportGroupCode),
      'reportTypeCode',
    ).map((type) => {
      const uniqByRepVers = uniqBy(
        output.filter((el) => el.reportGroupCode === item.reportGroupCode && el.reportTypeCode === type.reportTypeCode),
        'repVers',
      );

      return {
        reportGroupCode: type.reportGroupCode,
        reportTypeCode: type.reportTypeCode,
        key: `${type.reportGroupCode} - ${type.reportTypeCode}`,
        title: `${type.reportTypeCode} - ${type.reportTypeName}`,
        count: indicators.filter(
          (indicator) =>
            indicator.reportGroupCode === type.reportGroupCode && indicator.reportTypeCode === type.reportTypeCode,
        ).length,
        children: uniqByRepVers.map((el) => ({
          ...el,
          key: `${el.reportGroupCode} - ${el.reportTypeCode} - ${el.repVers}`,
          title: `${el.repVers} - ${el.reportCodeExt} - ${el.reportVersionName}`,
          count: indicators.filter(
            (indicator) =>
              indicator.reportGroupCode === el.reportGroupCode &&
              indicator.reportTypeCode === el.reportTypeCode &&
              indicator.repVers === el.repVers,
          ).length,
        })),
      };
    }),
  }));

  return [...withGroup, withoutGroup];
};
